import { AllDefectResponse, DefectResponse } from "@gtpl/shared-models/masters";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { Defect } from "./defect.entity";
import { DefectAdapter } from './dto/defect.adapter';
import { DefectDto } from "./dto/defect.dto";
import { DefectRequest } from "./dto/defect.request";
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { UserRequestDto } from "../currencies/dto/user-logs-dto";

@Injectable()
export class DefectService {
    constructor(
        private logService:LogsService,
        @InjectRepository(Defect) private repository: Repository<Defect>,
        private defectAdapter: DefectAdapter,
    ) { }

    async createDefect(defectDto: DefectDto, isUpdate: boolean, request: Request): Promise<DefectResponse> {
        try {
            let previousValue
console.log('**********createDefect***',defectDto)
            if (!isUpdate) {
                const defectEntity = await this.getDefect(defectDto.defectName);
                if (defectEntity) {
                    throw new DefectResponse(false, 11104, 'Defect already exists');
                }
            }
            else {
                const defectValue = await this.repository.findOne({where:{defectId:defectDto.defectId}})
                previousValue = defectValue.defectName
                const defectEntity = await this.getDefect(defectDto.defectName);
                if (defectEntity) {
                    if (defectEntity.defectId != defectDto.defectId) {
                        throw new DefectResponse(false, 11104, 'Defect already exists');
                    }
                }
            }
            const convertedDefectEntity: Defect = this.defectAdapter.conevertDtoToEntity(defectDto, isUpdate);
            const savedDefectEntity: Defect = await this.repository.save(convertedDefectEntity);
            const savedDefectDTO: DefectDto = this.defectAdapter.convertEntityToDto(savedDefectEntity);

            if (savedDefectDTO) {
                const presentVal = savedDefectDTO.defectName;
                const name =isUpdate ? 'update':'create'
             const userName = isUpdate ? savedDefectDTO.updatedUser : savedDefectDTO.createdUser
             const displayValue = isUpdate? 'Defect Updated Successfully': 'Defect Created Successfully'
            const newLogDto = new LogsDto(1,name, 'Defect', savedDefectDTO.defectId, true, displayValue,userName,previousValue,presentVal)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                const response = new DefectResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'defect Updated Successfully' : 'Defect Created Successfully', savedDefectDTO);
                return response;
            } else {
                throw new DefectResponse(false, 11106, 'Defect saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }


    async getAllDefects(req?:UserRequestDto): Promise<AllDefectResponse> {
        try {
            const defectDto: DefectDto[] = [];

            const defectEntities: Defect[] = await this.repository.find({
                order: { defectName: "ASC" },
            });

            if (defectEntities.length > 0) {
                defectEntities.forEach(defectEntity => {
                    const convertedDefectDto: DefectDto = this.defectAdapter.convertEntityToDto(defectEntity);
                    defectDto.push(convertedDefectDto);
                });
                const response = new AllDefectResponse(true, 11208, "Defect retrieved successfully", defectDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(0,'view', 'Defect', 0, true, 'Defects retrieved successfully',req.createdUser,'','')
                  let res = await this.logService.createLog(newLogDto);
                  console.log(res);
                  }
                return response;
            } else {
                //   console.log('yest')
                throw new DefectResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getDefect(defectName: string): Promise<Defect> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { defectName: defectName },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateDefect(req: DefectRequest): Promise<DefectResponse> {
        try {
            const defectExists = await this.getDefectById(req.defectId);
            if (defectExists) {
                if (req.versionFlag !== defectExists.versionFlag) {
                    throw new DefectResponse(false, 10113, 'Someone updated the current Defect information.Refresh and try again');
                } else {

                    const defectStatus = await this.repository.update(
                        { defectId: req.defectId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });

                    if (defectExists.isActive) {
                        if (defectStatus.affected) {
                            const defectResponse: DefectResponse = new DefectResponse(true, 10115, 'defect de-activated successfully');
                            return defectResponse;
                        } else {
                            throw new DefectResponse(false, 10111, 'defect is already deactivated');
                        }
                    } else {
                        if (defectStatus.affected) {
                            const defectResponse: DefectResponse = new DefectResponse(true, 10114, 'defect is activated successfully');
                            return defectResponse;
                        } else {
                            throw new DefectResponse(false, 10112, 'defect is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new DefectResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getDefectById(defectId: number): Promise<Defect> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { defectId: defectId },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getAllActiveDefects(): Promise<AllDefectResponse> {
        try {
            const defectEntities: Defect[] = await this.repository.find({
                select: ['defectId', 'defectName'], where: { isActive: true },
                order: { defectName: "ASC" },
            });
            if (defectEntities) {
                return new CommonResponse(true, 11208, "Defect retrieved successfully", defectEntities);
            }
            else {
                //   console.log('yest')
                throw new CommonResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

}